import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import SwipeableDrawer from "@mui/material/SwipeableDrawer"

// Components
import BottomDrawerHead from "./components/BottomDrawerHead";

BottomDrawer.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    disablePortal: PropTypes.bool,
    openMaxHeight: PropTypes.bool,
    noHeightLimit: PropTypes.bool,
    underTitle: PropTypes.element,
    maxHeight: PropTypes.string,
};

function BottomDrawer({title, subtitle, underTitle = null, open = false, onClose = () => {}, disablePortal= false, openMaxHeight = false, noHeightLimit = false, maxHeight = "70%", ...props}) {
    return (
        <SwipeableDrawer
            anchor={'bottom'}
            open={open}
            onClose={onClose}
            onOpen={() => {}} // onOpen is not used in this component but required
            sx={{
                zIndex: (theme) => theme.zIndex.modal + 1,
                '.MuiDrawer-paper': {
                    height: openMaxHeight ? '100vh' : 'inherit',
                    maxHeight: noHeightLimit ? 'calc(100% - 16px)' : maxHeight,
                    borderTopLeftRadius: 24,
                    borderTopRightRadius: 24,
                    position: 'fixed',
                    display: 'flex',
                    flexDirection: 'column',
                }
            }}
            disablePortal={disablePortal}
        >
            <BottomDrawerHead
                title={title}
                subtitle={subtitle}
                onClose={onClose}
            >
                {underTitle}
            </BottomDrawerHead>
            {props.children}
        </SwipeableDrawer>
    );
}

export default BottomDrawer;
